import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";

export const getRouter = () => {
  const router = createRouter({
    routeTree,
    scrollRestoration: true,
    // Single marketing page — do not prefetch unused route JS on hover/touch.
    defaultPreload: false,
    defaultPreloadStaleTime: 0,
  });

  return router;
};
